import http from './index'

export async function get(urlKey, params = {}) {
    try {
        const res = await http.get(urlKey, { params })
        return res
    } catch (err) {
        return Promise.reject(err)
    }
}

export async function post(urlKey, data = {}) {
    try {
        // let headers = {}
        // headers['Content-Type'] = 'application/json'
        const res = await http.post(urlKey, data)
        return res
    } catch (err) {
        return Promise.reject(err)
    }
}
